module.exports = __webpack_public_path__ + "img/IMG_2221-1200w.438537db.jpg";